module.exports = __webpack_public_path__ + "media/images/opiod-deaths-2020-dbc4e180dc8162473394554dda68d997.png";